import html2canvas from 'html2canvas';

import {REMOTE_MEDIA_ID, LOCAL_MEDIA_ID, SCREENSHOT_CANVAS_ID} from 'constants/session';
import {SessionScreenshotSubject} from 'interfaces';

import {sessionUtils} from './session';

// TODO: could we use html2canvas for this purpose as it supports video elements since 1.4.1?
export const getVideoScreenshot = (videoEl: HTMLVideoElement): string => {
    const width = videoEl.videoWidth;
    const height = videoEl.videoHeight;

    if (!width || !height) {
        return;
    }

    const canvas = document.getElementById(SCREENSHOT_CANVAS_ID) as HTMLCanvasElement;

    if (!canvas) {
        return;
    }

    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    context.drawImage(videoEl, 0, 0, width, height);
    return canvas.toDataURL('image/png', 1);
};

const fixDocumentForScreenshot = (documentCopy: Document) => {
    const hiddenElements = documentCopy.body.querySelectorAll('.screenshot-hidden');
    hiddenElements.forEach((item: any) => {
        item.style.display = 'none';
    });

    documentCopy.querySelector('noscript')?.remove();
};

export const getScreenshotBase64 = (subject: SessionScreenshotSubject, participantId?: string): Promise<string> => {
    if (subject === SessionScreenshotSubject.ParticipantVideo || subject === SessionScreenshotSubject.LocalVideo) {
        let containerSelector = `#${subject === SessionScreenshotSubject.ParticipantVideo ? REMOTE_MEDIA_ID : LOCAL_MEDIA_ID}`;
        if (participantId) {
            containerSelector = sessionUtils.getParticipantVideoSelector(participantId);
        }
        const videoElement = document.querySelector(`${containerSelector} > video`) as HTMLVideoElement;
        if (videoElement) {
            if (!videoElement.videoWidth || !videoElement.videoHeight) {
                return Promise.reject(new Error('Video element found with invalid dimensions'));
            }
            const base64 = getVideoScreenshot(videoElement);
            return base64 ? Promise.resolve(base64) : Promise.reject(new Error('Can not create video screenshot'));
        }
        return Promise.reject(new Error('Video element was not found'));
    }

    const node = document.querySelector('body');
    return html2canvas(node, {
        logging: true,
        useCORS: true,
        allowTaint: true,
        onclone: fixDocumentForScreenshot
    }).then((canvas) => canvas.toDataURL('image/png', 1));
};